<div class="modal-content">
  <div class="modal-header">
      <h5 class="modal-title" id="otp-order-label">{{'Xác thực OTP'}}</h5>
      <button type="button" class="close" (click)="dismiss()" *ngIf="isHasClose">
          <span aria-hidden="true"><img src="./../../../../assets/images/icon/close.svg" width="12px"
                  alt="Close" title="Đóng"></span>
      </button>
  </div>
  <div class="modal-body">
      <div class="modal-body-content">
        <label for="">{{'Vui lòng nhập mã xác thực (OTP) đã được gửi đến ứng dụng Authenticator của bạn'}}</label>
        <input-number [maxLength]="6" [isInteger]="true" [isSeparate]="false"
          [(amount)]="otp" [isTextAlignCenter]="true">
        </input-number>
      </div>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="!validate()" (click)="confirm()">{{'Xác thực'}}</button>
  </div>
</div>